module.exports = __webpack_public_path__ + "static/media/Windridge-Bylaws.8c2b30cc.pdf";